<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" title="Group Items" @hidden="onHidden"
                   @hide="onHide" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')" :is-loading="loading"
                   :content-in-form="false" scrollable>


    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import InventoryService from "@/modules/inventory/InventoryService";
  import GroupedItem from "@/modules/inventory/group-items/GroupedItem.model";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "GroupItemsModal",
    components: {
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        model: new GroupedItem(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.groupItemsModal,
      }),
    },
    methods: {
      ...mapActions(['hideGroupItemsModal']),
      onHide() {
      },
      onHidden() {
        this.model = new GroupedItem();
        this.hideGroupItemsModal();
      },
      async onSubmit() {
        this.hideGroupItemsModal();
      },
    },
  }
</script>

<style scoped>

</style>
